angular.module('app.api').factory('SharedApi', [
  'api',
  function SharedApi(api) {
    const sharedApi = {
      uploadUserProfilePicture: async (userId, payload) => {
        return api.post(`users/${userId}/profile/photo`, payload)
      },
      deleteUserProfilePicture: async userId => {
        return api.delete(`users/${userId}/profile/photo`)
      },

      getAllContractTypes: () => {
        return api.get(`contract-types`)
      },
      getAllOccupations: async () => {
        const result = await api.get(`occupations`)
        const data = result.data
        const filtered = data
          .filter(Boolean)
          .filter(
            item => item && item.professionId && item.professionId === 'law'
          )
        return {
          status: result.status,
          headers: result.headers,
          config: result.config,
          statusText: result.statusText,
          xhrStatus: result.xhrStatus,
          data: filtered,
        }
      },
      getAllCategories: () => {
        return api.get(`categories`)
      },
      getReferrer: async userId => {
        try {
          const raw = await api.get(`referrals?targetUser=${userId}`)
          if (raw.data.length > 0) {
            const referral = raw.data[0]
            if (referral.referrerName) {
              return referral.referrerName
            }
          }

          return ''
        } catch (error) {
          console.debug(`could not find referrer for ${userId}`)
          console.error(error)
          return ''
        }
      },
      getCategoryById: async categoryId => {
        const raw = await api.get(`categories/${categoryId}`)
        const {data, status, headers, config, statusText, xhrStatus} = raw
        const success = response => {
          return response
        }

        if (categoryId !== 3) return success(raw)

        // Sort jurisdictions
        console.debug('sorting jurisdictions')
        const {
          created,
          description,
          enabled,
          name,
          id,
          type,
          updated,
          specialties,
        } = data
        const other = specialties.find(x => x.name === 'Other Jurisdiction')
        const england = specialties.find(x => x.name.startsWith('England'))
        const rest = specialties.filter(
          x => x.name !== 'Other Jurisdiction' && !x.name.startsWith('England')
        )

        // Sort rest alphabetically
        const sortedRest = _.sortBy(rest, x => x.name.toLowerCase())

        const sorted = [england, ...sortedRest, other]
        const sortedData = {
          created,
          description,
          enabled,
          name,
          id,
          type,
          updated,
          specialties: sorted,
        }
        const result = {
          status,
          headers,
          config,
          statusText,
          xhrStatus,
          data: sortedData,
        }
        return result
      },
      getAllLocations: async payload => {
        const locations = await api.get(`locations`, {params: payload})
        const uk = locations.data.find(x => x.name === 'United Kingdom')
        const germany = locations.data.find(x => x.name === 'Germany')
        const london = locations.data.find(x => x.name === 'London')

        const ukChildren = locations.data.filter(
          x =>
            x.name !== 'London' &&
            x.name !== 'United Kingdom' &&
            x.parentId === uk.id
        )

        const germanyChildren = _.sortBy(
          locations.data.filter(
            x => x.name !== 'Germany' && x.parentId === germany.id
          ),
          x => x.name.toLowerCase()
        )

        const ukChildrenIds = new Set(ukChildren.map(x => x.id))
        const isAGrandchildOfUk = location =>
          // eslint-disable-next-line no-implicit-coercion
          !!location.parentId && ukChildrenIds.has(location.parentId)
        const restOfUk = locations.data.filter(x => isAGrandchildOfUk(x))
        // eslint-disable-next-line you-dont-need-lodash-underscore/uniq
        const ukLocations = _.uniq([london, ...ukChildren, ...restOfUk, uk])
        const nonUkLocations = locations.data.filter(
          x =>
            x.name !== 'United Kingdom' &&
            x.parentId !== uk.id &&
            x.name !== 'Germany' &&
            x.parentId !== germany.id
        )
        const sortedNonUk = _.sortBy(nonUkLocations, x => x.name.toLowerCase())

        const aToF = sortedNonUk.filter(x => x.name.match(/^[A-Fa-f]/))
        const gToZ = sortedNonUk.filter(x => x.name.match(/^[G-Zg-z]/))
        const nonUk = [...aToF, germany, ...germanyChildren, ...gToZ]

        // eslint-disable-next-line you-dont-need-lodash-underscore/uniq
        const result = _.uniq([...ukLocations, ...nonUk])

        return _.extend(locations, {data: result})
      },
      getAllRegions: () => {
        return api.get(`regions`)
      },
      getAllLanguages: () => {
        return api.get(`languages`)
      },
      getAllNationalities: async () => {
        const countries = await api.get(`countries`)

        const nationalities = await api.get(`nationalities`)
        const {
          data,
          status,
          headers,
          config,
          statusText,
          xhrStatus,
        } = nationalities
        const formatted = data
          .filter(nationality => nationality.demonyms.length)
          .map(nationality => {
            const {code, demonyms} = nationality
            const country = countries.data.find(x => x.code === code)
            if (country !== undefined && country !== null) {
              const {name} = country
              const nonEmptyDemonyms =
                demonyms.filter(x => x && x.length > 0).length > 0
              const [first, ...other] = demonyms
              const formatted = nonEmptyDemonyms ? `${first} (${name})` : name
              const formattedDemonyms = nonEmptyDemonyms
                ? [formatted, ...other]
                : [formatted]
              return {
                code,
                demonyms: formattedDemonyms,
              }
            }

            return {
              code,
              demonyms: demonyms,
            }
          })

        const british = formatted.find(nationality => nationality.code === 'GB')
        const rest = formatted.filter(nationality => nationality.code !== 'GB')
        const sorted = [british, ...rest]

        return {
          status,
          headers,
          config,
          statusText,
          xhrStatus,
          data: sorted,
        }
      },
      getAllSchools: () => {
        return api.get(`schools`)
      },
      getUserById: id => {
        return api.get(`users/${id}`)
      },
      getAllActions: payload => {
        return api.get(`actions`, {params: payload})
      },
      addSchool: payload => {
        return api.post('schools', payload)
      },
    }

    return sharedApi
  },
])



// WEBPACK FOOTER //
// ./scripts/shared/shared.api.js